import { render, staticRenderFns } from "./AdditionalMainLinks.vue?vue&type=template&id=4984bf0a&scoped=true&"
import script from "./AdditionalMainLinks.vue?vue&type=script&lang=js&"
export * from "./AdditionalMainLinks.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalMainLinks.vue?vue&type=style&index=0&id=4984bf0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984bf0a",
  null
  
)

export default component.exports